import { validateInteger } from "@/common/validation/Validators.js";
import { ChevronDownIcon, TrashIcon } from "@heroicons/react/20/solid";
import { validateFloat } from "@/components/common/validation/Validators";
import {
	format,
	parse
} from "date-fns";
import { cloneDeep } from "lodash";
import { useState } from "react";
import DatePicker from "react-datepicker";
import { connect } from "react-redux";
import Select from "react-select";
import { TimeInputFormat } from "../common/DateComponents";

const weekdayOptions = [
	{
		label: "Sunday",
		value: 0,
	},
	{
		label: "Monday",
		value: 1,
	},
	{
		label: "Tuesday",
		value: 2,
	},
	{
		label: "Wednesday",
		value: 3,
	},
	{
		label: "Thursday",
		value: 4,
	},
	{
		label: "Friday",
		value: 5,
	},
	{
		label: "Saturday",
		value: 6,
	},
];

const PunchClockRow = ({ disabled, workLocationOptions, pClock, data, setData }) => {
	const updateSetting = (field, value) => {
		setData({
			...data,
			[field]: value,
		});
	};
	const updateArraySetting = ({ field, index, indexName, value }) => {
		const array = cloneDeep(data[field]);
		const objectAtArray = array[index];

		objectAtArray[indexName] = value;

		setData({
			...data,
			[field]: array,
		});
	};
	const addItemInArray = (field, value) => {
		const array = cloneDeep(data[field]) || [];

		array.push(value);

		setData({
			...data,
			[field]: array,
		});
	};
	const removeItemInArray = (field, index) => {
		const array = cloneDeep(data[field]) || [];

		array.splice(index, 1);

		setData({
			...data,
			[field]: array,
		});
	};

	const {
		name: pClockName,
		id: serialNumber,
		skipDoublePunch,
		location,
		automatedBreaks,
		round,
		roundEntryTime,
	} = data;

	const [expand, setExpand] = useState(false);
	const lastSeenDate = pClock?.lastSeen ? new Date(pClock?.lastSeen) : undefined
	const lastPClockEntry = lastSeenDate ? format(lastSeenDate, "do MMMM yyyy HH:mm") : "Never"

	return (
		<div
			className="form-section col-xs-12"
			style={{ padding: 10, marginTop: 0 }}
		>
			<div
				className="col-xs-12"
				style={{ marginTop: 20 }}
			>
				<div className="col-xs-3">
					<div className="form-material form-container">
						<label htmlFor="name">Name</label>
						<input
							// style={{width: "20rem", height: "4rem"}}
							className="form-control form-input"
							type="text"
							value={pClockName}
							autoComplete="off"
							onChange={(e) => {
								const value = e.target.value;
								updateSetting(e.target.name, value);
							}}
							id="name"
							name="name"
						/>
					</div>
				</div>
				<div className="col-xs-3">
					<div className="form-material form-container">
						<label htmlFor="id">Serial Number</label>
						<input
							// style={{width: "20rem", height: "4rem"}}
							className="form-control form-input"
							type="text"
							disabled={pClock?.id}
							value={serialNumber}
							autoComplete="off"
							id="id"
							name="id"
							onChange={(e) => {
								const value = e.target.value;
								updateSetting(e.target.name, value);
							}}
						/>
					</div>
				</div>
				<div className="col-xs-5">
					<div className="form-material form-container">
						<label htmlFor="workLocation">Work Location</label>
						<Select
							isDisabled={disabled}
							options={workLocationOptions}
							isClearable
							onChange={(selected) => {
								updateSetting("location", selected?.value || null);
							}}
							value={workLocationOptions?.find((l) => l.value === location)}
							classNamePrefix="react-select-search"
						/>
					</div>
				</div>
				<div className="col-xs-1 pr-0">
					<div
						className="btn btn-primary pull-right"
						style={{ marginTop: "1rem" }}
						onClick={() => setExpand(!expand)}
					>
						<ChevronDownIcon
							style={{
								height: "1.5em",
								float: "left",
								transform: expand ? "rotateX(180deg)" : "rotateX(0deg)",
								transition: "transform 0.3s ease-in-out",
							}}
						/>
					</div>
				</div>
			</div>
			<div className="col-xs-12" style={{marginBottom: 10}}>
				<div className="help-block">
					{`Last Punch Clock Entry: ${lastPClockEntry}`}
				</div>
			</div>
			{expand ? (
				<>
					<div className="col-xs-12">
						<div className="form-material form-container">
							<label className="css-input switch switch-sm switch-success">
								<input
									type="checkbox"
									onChange={(e) => {
										updateSetting(e.target.name, !skipDoublePunch);
									}}
									checked={skipDoublePunch}
									className="checkbox-toggle"
									disabled={disabled}
									name="skipDoublePunch"
								/>
								<span />
								Skip double punch in
							</label>
						</div>
					</div>
					<div
						className="-inner-section col-xs-12"
						style={{ padding: 10, paddingRight: 20 }}
					>
						<div
							className="row"
							style={{ paddingLeft: 10, paddingRight: 10, paddingTop: 0, paddingBottom: 0 }}
						>
							<div className="col-xs-12 pl-0 pr-0">
								<div className="col-xs-6">
									<h4>Automated Breaks Setup</h4>
								</div>
								<button
									type="button"
									className="btn btn-primary pull-right"
									onClick={(e) => {
										addItemInArray("automatedBreaks", {});
									}}
								>
									Add Break
								</button>
							</div>
						</div>
						{automatedBreaks?.map((aB, index) => {
							return (
								<BreakSetup
									updateSetting={(indexName, value) => {
										updateArraySetting({
											field: "automatedBreaks",
											index,
											indexName,
											value,
										});
									}}
									remove={(index) => {
										removeItemInArray("automatedBreaks", index);
									}}
									index={index}
									duration={aB.duration}
									hours={aB.hours}
								/>
							);
						})}
					</div>
					<div
						className="col-xs-12"
						style={{ marginTop: 10 }}
					>
						<div className="col-xs-3">
							<div className="form-material form-container">
								<label htmlFor="round">Round Timesheet Minutes</label>
								<input
									className="form-control form-input"
									value={round}
									type="text"
									onChange={(e) => {
										const value = validateInteger(e.target.value);
										if (value < 0 || value >= 61) {
											return;
										}

										updateSetting(e.target.name, value);
									}}
									autoComplete="off"
									id="round"
									name="round"
								/>
							</div>
						</div>
					</div>
					<div
						className="-inner-section col-xs-12"
						style={{ padding: 10, paddingRight: 20, marginTop: 0 }}
					>
						<div
							className="row"
							style={{ paddingLeft: 10, paddingRight: 10, paddingTop: 0, paddingBottom: 0 }}
						>
							<div className="col-xs-12 pl-0 pr-0">
								<div className="col-xs-6">
									<h4>Round Timesheet Time-in</h4>
								</div>
								<button
									type="button"
									className="btn btn-primary pull-right"
									onClick={(e) => {
										addItemInArray("roundEntryTime", {});
									}}
								>
									Add Time-in
								</button>
							</div>
						</div>
						{roundEntryTime?.map((rET, index) => {
							return (
								<RoundTimesheet
									updateSetting={(indexName, value) => {
										updateArraySetting({
											field: "roundEntryTime",
											index,
											indexName,
											value,
										});
									}}
									remove={(index) => {
										removeItemInArray("roundEntryTime", index);
									}}
									key={'roundEntryTime' + index}
									index={index}
									time={rET.time}
									weekdays={rET.weekdays}
								/>
							);
						})}
					</div>
				</>
			) : null}
		</div>
	);
};

const BreakSetup = ({ duration, hours, index, updateSetting, remove }) => {
	return (
		<>
			<div
				className="form-inner-section col-xs-12"
				style={{ padding: 20, paddingBottom: 0, marginTop: 5, marginBottom: 5 }}
			>
				<div className="col-xs-3">
					<div className="form-material form-container">
						<label htmlFor={`hours[${index}]`}>Add Break After</label>
						<input
							className="form-control form-input"
							value={hours}
							type="text"
							onChange={(e) => {
								const value = validateFloat(e.target.value);
								updateSetting(e.target.name, value);
							}}
							autoComplete="off"
							id={`hours[${index}]`}
							name="hours"
							placeholder="Hours"
						/>
					</div>
				</div>
				<div className="col-xs-3">
					<div className="form-material form-container">
						<label htmlFor={`duration${index}`}>Break Length</label>
						<input
							className="form-control form-input"
							value={duration}
							type="text"
							autoComplete="off"
							onChange={(e) => {
								const value = validateInteger(e.target.value);
								updateSetting(e.target.name, value);
							}}
							id="duration"
							name="duration"
							placeholder="Minutes"
						/>
					</div>
				</div>
				<div className="col-xs-6">
					<button
						style={{ marginTop: "1.5rem" }}
						className="btn btn-xs btn-danger pull-right"
						type="button"
						onClick={(e) => {
							remove(index);
						}}
					>
						<TrashIcon className="w-6 h-6" style={{ verticalAlign: "sub" }} />
					</button>
				</div>
			</div>
		</>
	);
};

const RoundTimesheet = ({ weekdays, time, index, updateSetting, remove }) => {
	const today = new Date();
	const timeIn = time && parse(time, "HH:mm", new Date());

	return (
		<>
			<div
				className="form-inner-section col-xs-12"
				style={{ padding: 20, paddingBottom: 0, marginTop: 5, marginBottom: 5 }}
			>
				<div className="col-xs-3">
					<div className="form-material form-container">
						<label htmlFor={`timeIn${index}`}>Time In</label>
						<DatePicker
							selected={timeIn}
							//TODO
							onChange={(e) => {
								const value = format(e, "HH:mm");
								updateSetting("time", value);
							}}
							showTimeSelect
							showTimeSelectOnly
							timeIntervals={15}
							timeCaption="Time"
							dateFormat="h:mm aa"
							customInput={<TimeInputFormat />}
						/>
					</div>
				</div>
				<div className="col-xs-8">
					<div className="form-material form-container">
						<label htmlFor={`weekdays${index}`}>On Weekdays</label>
						<Select
							classNamePrefix="react-select-search"
							options={weekdayOptions}
							value={weekdays?.map((w) => weekdayOptions.find(({ value }) => value === w))}
							onChange={(e) => {
								const value = e?.map(({ value }) => value);
								updateSetting("weekdays", value);
							}}
							isMulti
						/>
					</div>
				</div>
				<div className="col-xs-1">
					<button
						style={{ marginTop: "1.5rem" }}
						className="btn btn-xs btn-danger pull-right"
						type="button"
						onClick={(e) => {
							remove(index);
						}}
					>
						<TrashIcon className="w-6 h-6" style={{ verticalAlign: "sub" }} />
					</button>
				</div>
			</div>
		</>
	);
};

const mapStateToProps = (state) => {
	const workLocations = state?.workLocation?.workLocationSettings?.types;
	const workLocationOptions = workLocations?.map((l) => ({
		label: l.name,
		value: l.id,
	}));
	return {
		workLocationOptions,
	};
};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(PunchClockRow);
